import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Alert from "@mui/material/Alert";
import { useLocation } from "react-router-dom";

// icons
import TimelineIcon from "@mui/icons-material/Timeline";
import GroupIcon from "@mui/icons-material/Group";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";

// rutas de peticiones axios
import api from "../../service/api";

import MinimalPage from "../../layout/MinimalPage";

import { useParams } from "react-router-dom";

// estilos
import { styled } from "@mui/material/styles";

// componentes importados
import Movimientos from "./DatosMovimientos";
import Adjuntos from "./DatosAdjuntos";
import Agregados from "./DatosAgregados";
import Iniciadores from "./DatosIniciadores";
import Tarjetas from "./Tarjetas";
import DatosBasicos from "./DatosBasicos";
import DatosSituacion from "./DatosSituacion";
import TabsMenu from './TabsMenu';

import { setError } from "../../reducers/appSlice";

// declaración de componentes
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}

    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Div = styled("div")(({ theme }) => ({
  marginBottom: 15,
}));

const Alerta = styled(Alert)(({ theme }) => ({
  width: "100%",
  "& > * + *": {
    marginTop: theme.spacing(2),
    marginBottom: 15,
    color: "#799f4f",
  },
}));

const Div2 = styled("div")(({ theme }) => ({
  flexGrow: 1,
  width: "100%",
  backgroundColor: theme.palette.background.paper,
}));

// acá arranca mi componente
const VerTramite = (props) => {
  const dispatch = useDispatch();

  const location = useLocation();
  const { from } = location.state || { from: { pathname: "/" } };

  const [value, setValue] = useState(1);
  const [existenInvolucrados, setExistenInvolucrados] = useState(false);
  const [tramite_expediente, setTramiteExpediente] = useState(false);
  const [existeTramite, setExisteTramite] = useState(false);
  const [tieneSituacion, setTieneSituacion] = useState(false);
  const [datos_tramite, setDatosTramite] = useState([]);
  const [datos_involucrados, setDatosInvolucrados] = useState([]);
  const [datos_situacion, setDatosSituacion] = useState("");
  const [cant_folios, setCantFolios] = useState(0);

  const [soporte, setSoporte] = useState("");
  const [permiso, setPermiso] = useState("");
  const [tienePermisoAdjunto, setTienePermisoAdjunto] = useState("N");
  const [tienePermisoAdjunto2, setTienePermisoAdjunto2] = useState("N");
  const [numeroExp, setNumeroExp] = useState("");
  const [tramiteid] = useState(useParams().tramiteId);
  const [dibujar, setDibujar] = useState(false);
  const [loadPantalla, setLoadPantalla] = useState(true);
  const [iniciadorId, setIniciadorId] = useState(null);
  const [filtro] = useState({
    tramiteId: useParams().tramiteId,
  });

  // migas
  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    {
      nombre:
        from.pathname === "/bandeja_entrada"
          ? "Bandeja de entrada"
          : "Consulta",
      ruta: from.pathname,
    },
    { nombre: "Información general", ruta: "" },
  ];

 
 /*  const buscarTramiteAmin = async (filtro) => {
    setLoadPantalla(true);
  
    try {
      const res = await api.verTramiteAdmin(filtro);
  
      const tramites = Array.isArray(res.data?.tramite)
        ? res.data.tramite
        : [];
  
      const involucrados = Array.isArray(res.data?.involucrados)
        ? res.data.involucrados
        : [];
  
      
      setDatosSituacion(res?.data?.situacion);
      setTieneSituacion(res?.data?.situacion !=="");
  
      setDatosTramite(tramites);
      setDatosInvolucrados(involucrados);
    
  
      setExisteTramite(tramites.length > 0);
      setExistenInvolucrados(involucrados.length > 0);
  
      if (tramites.length === 0) {
        dispatch(setError("No se encontró el trámite."));
        return;
      }
  
      const tramite = tramites[0];
  
      setCantFolios(tramite.cant_folios ?? 0);
      setSoporte(tramite.soporte ?? "");
      setTramiteExpediente(tramite.nro_expediente);
  
      dibujarMenu(
        tramite.soporte,
        tramite.nro_expediente,
        tramite.nro_tramite,
        tramite.fecha_expediente,
        tramite.fecha_tramite
      );
  
      if (tramite.iniciador_id) {
        verCaratulaPermisos(tramite.iniciador_id);
        setIniciadorId(tramite.iniciador_id);
      }
  
      setValue(2);
    } catch (e) {
      console.error("Error al cargar el trámite:", e);
  
      dispatch(
        setError(e.response?.data?.error)
      );
    } finally {
      setLoadPantalla(false);
    }
  }; */
  const buscarTramiteAmin = async (filtro) => {
    setLoadPantalla(true);
  
    try {
      const res = await api.verTramiteAdmin(filtro);
      if (Array.isArray(res.data?.errores) && res.data.errores.length > 0) {

        const erroresAgrupados = res.data.errores.reduce((acc, error) => {
      
          const mensaje = error.mensaje
            ?.replace(/^Error:\s*/i, "")
            .trim();
      
          if (!acc[mensaje]) {
            acc[mensaje] = [];
          }
      
          acc[mensaje].push(error.seccion);
      
          return acc;
        }, {});
      
        const mensajeError = Object.entries(erroresAgrupados)
          .map(([mensaje, secciones]) =>
            `${secciones.join(" / ")}: ${mensaje}`
          )
          .join("\n");
      
        dispatch(setError(mensajeError));
      }

        const tramites = Array.isArray(res.data?.tramite)
          ? res.data.tramite
          : [];

        const involucrados = Array.isArray(res.data?.involucrados)
          ? res.data.involucrados
          : [];

        setDatosSituacion(res.data?.situacion ?? "");
        setTieneSituacion((res.data?.situacion ?? "") !== "");

        setDatosTramite(tramites);
        setDatosInvolucrados(involucrados);
  
      setExisteTramite(tramites.length > 0);
      setExistenInvolucrados(involucrados.length > 0);
  
      if (tramites.length === 0) {
        dispatch(setError("No se encontró el trámite."));
  
        // No dejamos estados anteriores
        setCantFolios(0);
        setSoporte("");
        setTramiteExpediente(false);
        setDibujar(false);
  
        return;
      }
  
      const tramite = tramites[0];
  
      setCantFolios(tramite.cant_folios ?? 0);
      setSoporte(tramite.soporte ?? "");
      setTramiteExpediente(tramite.nro_expediente ?? false);
  
      dibujarMenu(
        tramite.soporte ?? "",
        tramite.nro_expediente ?? null,
        tramite.nro_tramite ?? null,
        tramite.fecha_expediente ?? null,
        tramite.fecha_tramite ?? null
      );
  
      if (tramite.iniciador_id) {
        verCaratulaPermisos(tramite.iniciador_id);
        setIniciadorId(tramite.iniciador_id);
      }
  
      setValue(2);
    } catch (e) {
      console.error("Error al cargar el trámite:", e);
  
      // Mostrás el error, pero NO impedís que cargue la pantalla
      dispatch(
        setError(
          e.response?.data?.error ??
          "Ocurrió un error al cargar algunos datos del trámite."
        )
      );
  
      // Dejamos estados seguros para que React pueda renderizar
      setDatosTramite([]);
      setDatosInvolucrados([]);
      setDatosSituacion("");
  
      setExisteTramite(false);
      setExistenInvolucrados(false);
      setTieneSituacion(false);
  
      setCantFolios(0);
      setSoporte("");
      setDibujar(false);
    } finally {
      // SIEMPRE se ejecuta
      setLoadPantalla(false);
    }
  };
  const verCaratulaPermisos = (org_id) => {
    api
      .verCaratula({
        organismo_iniciador: org_id,
      })
      .then((res) => {
        setPermiso(res.data);
      })
      .catch((e) => {
        console.log(e);
        console.log("Error al cargar los datos");
      });
  };

  async function verificarPermisoAdjuntos(filtro) {
    try {
      let dato = {
        tra_id: filtro.tramiteId,
      };
      let res = await api.buscarPermisoAdjuntos(dato);
      setTienePermisoAdjunto(res.data[0].tiene_permiso);
      if (res.data[0].tiene_permiso === "S") {
        verCantidadAdjuntos(filtro);
      }
    } catch (e) {
      dispatch(
        setError("Error al consultar los permisos en documentos adjuntos")
      );
    }
  }

  async function verCantidadAdjuntos() {
    try {
      let dato = {
        tramiteId: filtro.tramiteId,
      };
      let res = await api.verCantidadAdjuntos(dato);
      if (res.data[0].adjuntos > 0) {
        setTienePermisoAdjunto2("S");
      } else {
        setTienePermisoAdjunto2("N");
      }
    } catch (e) {
      dispatch(setError("Error al consultar la cantidad de adjuntos"));
    }
  }

  function actualizarDatos() {
    buscarTramiteAmin(filtro);
  }

  function dibujarMenu(soporte,expe,tra,fexpe,ftra) {
    if(soporte != ""){
      // número de expediente o trámite para mostrar //
      if ((expe != null) && (fexpe === ftra)) {
        setNumeroExp(' del EXPEDIENTE ' + expe);
      } else if ((expe != null && tra != null) && (fexpe != ftra)) {
        setNumeroExp(' del EXPEDIENTE ' + expe);
      } else if ((expe === null && tra != null)) {
        setNumeroExp(' del TRÁMITE INTERNO ' + tra);
      }
      // fin //
      setDibujar(true);
    }
  }

  useEffect(() => {
    buscarTramiteAmin(filtro);
    verificarPermisoAdjuntos(filtro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }
  return (
    <>
      <MinimalPage breadcrumbs={breadcrumbs} disableCheckAuth loading={loadPantalla}>
        {/* cards */}
           {datos_tramite.map((itemTramite) => (
            <Div key={itemTramite.id ?? itemTramite.nro_tramite}>
              <Tarjetas
                nro_expediente={itemTramite.nro_expediente}
                nro_tramite={itemTramite.nro_tramite}
                fecha_expediente={itemTramite.fecha_expediente}
                fecha_tramite={itemTramite.fecha_tramite}
              />

              <DatosBasicos
                tramiteid={tramiteid}
                asunto={itemTramite.asunto}
                tema={itemTramite.tema}
                iniciador={itemTramite.iniciador}
                iniciador_id={itemTramite.iniciador_id}
                visibilidad={itemTramite.visibilidad}
                soporte={itemTramite.soporte}
                cant_folios={itemTramite.cant_folios}
                observacion={itemTramite.observacion}
                tramite_expediente={tramite_expediente}
                permiso={permiso}
                permisos={tienePermisoAdjunto2}
                funcionImp={props.funcion}
              />

              <DatosSituacion
                datos_situacion={datos_situacion}
                existe={tieneSituacion}
              />
            </Div>
          ))}
       {dibujar && datos_tramite.length > 0 ? (
          <TabsMenu
            existe={existeTramite}
            involucrados={existenInvolucrados}
            permiso_adjuntos={tienePermisoAdjunto}
            involucrados_datos={datos_involucrados}
            tramite={filtro.tramiteId}
            funcion={props.funcion}
            cant_folios={cant_folios}
            soporte={datos_tramite[0]?.soporte ?? ""}
            pathruta={from.pathname}
            actualizarDatos={actualizarDatos}
            numero={numeroExp}
            iniciador_id={iniciadorId}
            situacion={datos_situacion ?? ""}
            datos_tramite={datos_tramite}
          />
        ) : null}
      </MinimalPage>
    </>
  );
};

export default VerTramite;
